import { render, staticRenderFns } from "./score-rubic-form.component.vue?vue&type=template&id=7bf9a358&"
import script from "./score-rubic-form.component.ts?vue&type=script&lang=ts&"
export * from "./score-rubic-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./score-rubic-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports